module.exports = __webpack_public_path__ + "static/media/transactionFees.36dc2215.svg";